module.exports = __webpack_public_path__ + "img/d&cmusic-departures-review.c8cdef64.png";